import React from 'react'

import style from '@styles/form/Dropdown.module.scss'

interface Props {
  label: string
  inputId: string
  options: string[][]
}

const Dropdown = React.forwardRef(
  ({ label, inputId, options }: Props, ref: React.Ref<HTMLSelectElement>) => (
    <div className={style.container}>
      <label className={style.label} htmlFor={inputId}>
        {label}
      </label>
      <select className={style.select} name={inputId} ref={ref}>
        {options.map(option => (
          <option key={option[0]} value={option[0]}>
            {option[1]}
          </option>
        ))}
      </select>
    </div>
  )
)

export { Dropdown }
